import React from 'react';

import ContinueAsPage from '../../containers/continueAs';

const continueAs = () => <ContinueAsPage />;

export default continueAs;
